import * as React from "react";

const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "id",
            label: "id",
            mandatory: true,
            column: 1,
            type: "unvisible"
        },
        {
            name: "machineType",
            label: t ? t("common.machine_type") : "Typ maszyny",
            column: 1,
            type: "enum",
            enumType: "enums/machineType",
            mandatory: true,
            readOnly: true,
        },
        {
            name: "model",
            label: t ? t("common.model") : "Model",
            mandatory: true,
            column: 1,
        },
        {
            name: "active",
            label: t ? t("common.active") : "Aktywny",
            mandatory: true,
            type: "boolean",
            column: 1,
        }
    ]


});

export default fields;